















import { Component, Vue, Mixins } from "vue-property-decorator";
import { Getter } from "vuex-class";

import ScholarshipProgram from "./ScholarshipProgram.vue";
import PrizeProgram from "./PrizeProgram.vue";

@Component({
  components: {
    "scholarship-program": ScholarshipProgram,
    "prize-program": PrizeProgram
  }
})
export default class gachaProgram extends Vue {
  @Getter("gachaTypeParameter") gachaTypeParameter!: object;
}
